import localforage from "localforage";

export const queryStorage = localforage.createInstance({
  name: "react-query",
  storeName: "query-cache",
});
